<!-- Admin bar - only shown when user is an admin -->
@if (isAdmin()) {
<div class="admin-bar">
  <div class="admin-bar-content">
    <div class="admin-bar-left">
      <span class="admin-login-text">You are logged in as administrator</span>
    </div>
    <div class="admin-bar-right">
      <button class="admin-button" aria-label="Portal" (click)="navigateToHome()">
        <svg-icon alt="" src="assets/icons/common/home.svg" svgClass="admin-icon"></svg-icon>
        <span>Portal</span>
      </button>
      <button class="admin-button" aria-label="Settings" (click)="navigateToSites()">
        <svg-icon alt="" src="assets/icons/common/gear.svg" svgClass="admin-icon"></svg-icon>
        <span>Settings</span>
      </button>
    </div>
  </div>
</div>
}